import React from 'react';
import { Box } from '@mui/material';
import { AU } from '../../styles/tokensAU';

// Círculo azul suave con un ícono azul al centro (éxito, correo…). Es decorativo: el título dice lo que pasó.
const CirculoIcono = ({ children }) => (
  <Box
    aria-hidden="true"
    sx={{
      width: 72,
      height: 72,
      borderRadius: '50%',
      bgcolor: AU.azulSuave,
      color: AU.azul,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& svg': { fontSize: 40 },
    }}
  >
    {children}
  </Box>
);

export default CirculoIcono;
